import React from 'react';

import { ArrowRight } from '@carbon/icons-react';

import TextButton from 'components/Buttons/TextButton/TextButton';

import { ImportToastType } from 'app/models';

import block from 'utils/bem-css-modules';
import { formatMessage } from 'utils/messages/utils';

import style from './ImportToastMessage.module.pcss';

const b = block(style);

interface ImportToastMessageProps {
  status: ImportToastType;
  fileName: string;
  handleActionButtonClick: () => void;
}

const getToastPropertiesByStatus = (status: ImportToastType, fileName: string, handleActionButtonClick: () => void) => {
  const map: Record<
    ImportToastType,
    {
      title: string;
      message: string;
      actionButtonText: string;
      actionButtonOnClick: () => void;
    }
  > = {
    [ImportToastType.STARTED]: {
      title: formatMessage('IMPORT_STARTED'),
      message: fileName
        ? formatMessage('IMPORT_STARTED_MESSAGE', { fileName })
        : formatMessage('IMPORT_STARTED_MESSAGE_NO_NAME'),
      actionButtonText: formatMessage('VIEW_STATUS'),
      actionButtonOnClick: handleActionButtonClick
    },
    [ImportToastType.COMPLETED]: {
      title: formatMessage('IMPORT_COMPLETED'),
      message: fileName
        ? formatMessage('IMPORT_COMPLETED_MESSAGE', { fileName })
        : formatMessage('IMPORT_COMPLETED_MESSAGE_NO_NAME'),
      actionButtonText: formatMessage('VIEW_STATUS'),
      actionButtonOnClick: handleActionButtonClick
    },
    [ImportToastType.FAILED]: {
      title: formatMessage('IMPORT_FAILED'),
      message: fileName
        ? formatMessage('IMPORT_FAILED_MESSAGE', { fileName })
        : formatMessage('IMPORT_FAILED_MESSAGE_NO_NAME'),
      actionButtonText: formatMessage('GO_TO_IMPORT_ERRORS'),
      actionButtonOnClick: handleActionButtonClick
    }
  };
  return map[status];
};

const ImportToastMessage: React.FC<ImportToastMessageProps> = ({
  status,
  fileName,
  handleActionButtonClick
}: ImportToastMessageProps) => {
  const toastProperties = getToastPropertiesByStatus(status, fileName, handleActionButtonClick);
  return (
    <>
      <div data-testid="toast-title" className={b('title')}>
        <b>{toastProperties.title}</b>
      </div>

      <div data-testid="toast-message">{toastProperties.message}</div>

      <div className={b('actionButton')}>
        <TextButton
          text={toastProperties.actionButtonText}
          minimal
          type="button"
          rightIcon={<ArrowRight />}
          onClick={toastProperties.actionButtonOnClick}
          testId={'toast-action-button'}
        />
      </div>
    </>
  );
};

export default ImportToastMessage;
